import { List, ListItem } from '@fs/zion-ui'
import React from 'react'

export default function DeleteMembersList({ members }) {
  return (
    <List>
      {members.map((member) => (
        <ListItem
          key={member.memberCisId}
          primaryText={member.contactName}
          endElement={<ListItem.MetaText text={member.memberCisId.split('.')[2]} />}
        />
      ))}
    </List>
  )
}
